import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-about',
  templateUrl: 'about.component.html',
  styleUrls: ['about.component.scss'],
})
export class AboutComponent extends BaseSegmentComponent implements OnInit, OnDestroy {

  brandData: any = [];
  private subscription: Subscription;

  get brandLabel(): string {
    return _.get(this.itemDetail, 'details.brandLabel', '');
  }

  getRefLowerCase(ref: string): string {
    return _.lowerCase(ref);
  }

  ngOnInit() {
    this.subscription = this.dataChange.subscribe((data: any) => {
      this.setData();
    });
    this.setData();
  }

  ngOnDestroy() {
    if (this.subscription) {  this.subscription.unsubscribe(); }
  }

  private setData() {
    this.brandData = this.groupMarketingByType(this.groupMarketingByCode('brand'));
  }
}
